import Swiper from "swiper/js/swiper.js";

export default class mainCarousel {
  constructor(options) {
    const _defaults = {
      mainCarousel: ".js-main-carousel"
    };
    this.defaults = Object.assign({}, _defaults, options);
  }

  init() {
    this.carousel();
  }

  carousel() {
    if (!this.getMainCarousel().length) {
      return
    }
    let _self = this;
    var mediumSwiperItems = new Swiper(this.getMainCarousel(), {
      effect: "fade",
      on: {
        init: function () {
          setTimeout(function () {
            $('.main-carousel__item').addClass('has-transition');
          }, 1000)
        },
      },
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      pagination: {
        el: ".main-carousel-pagination",
        clickable: true
      },
    });
  }

  getMainCarousel() {
    return $(this.defaults.mainCarousel);
  }
}


// WEBPACK FOOTER //
// ./static/js/components/MainCarousel.js